var _this = this,
    _jsxFileName = "/builds/zillow-offers/common/node/zrs-zillow-offers/src/components/Page/Page.jsx";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { spaceMixin, mediaMixin } from '@zillow/constellation';
import styled, { css } from 'styled-components';
export var PageWrapper = styled.div.withConfig({
  displayName: "Page__PageWrapper",
  componentId: "sc-1acryin-0"
})(["background-color:", ";min-height:", ";text-align:", ";", ";@media (min-width:1440px){margin-bottom:", ";}"], function (props) {
  return props.theme.constellation.colors.gray100;
}, function (props) {
  return props.withoutNav ? '100vh' : 'calc(100vh - 50px)';
}, function (props) {
  return props.centeredContent ? 'center' : 'left';
}, function (props) {
  return mediaMixin('lg', css(["display:", ";flex-direction:column;justify-content:center;min-height:", ";"], props.centeredContent ? 'flex' : 'block', props.withoutNav ? '100vh' : 'calc(100vh - 80px)'));
}, spaceMixin('lg'));
export var PageContent = styled.main.withConfig({
  displayName: "Page__PageContent",
  componentId: "sc-1acryin-1"
})(["margin:0 auto;max-width:", ";"], function (props) {
  return props.maxWidth ? props.maxWidth + "px" : null;
});
/**
 * A page wrapper that creates a gray background to cover the page.
 * This would most commonly be used to place [`<Card>`](http://constellation.pages.zgtools.net/constellation-site/constellation-api.html#card) elements on, but any content is allowed.
 */

var Page = function Page(props) {
  return /*#__PURE__*/React.createElement(PageWrapper, _extends({}, props, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(PageContent, {
    maxWidth: props.maxWidth,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 9
    }
  }, props.children));
};

Page.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Should the content within the page be vertically centered?
   */
  centeredContent: PropTypes.bool,
  children: PropTypes.node,

  /**
   * The max width of the page content (in pixels).
   */
  maxWidth: PropTypes.number,

  /**
   * Is the page rendered without top nav? If true, the page
   * set its min-height to 100vh and will not leave room for a top nav.
   * */
  withoutNav: PropTypes.bool
} : {};
Page.defaultProps = {
  centeredContent: false,
  children: null,
  maxWidth: null,
  withoutNav: false
};
export default Page;